var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message != '')?_c('v-alert',{attrs:{"border":"left","dense":"","dismissible":"","text":"","transition":"fade-transition","type":_vm.type}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }